// removed by extract-text-webpack-plugin
module.exports = {"root":"s7_vq"};